import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import If from "../../utils/react-if";
import { connect } from "react-redux";
import { extractElementData } from "../../utils/objects-utils";

const STYLE_LINE = {
  fill: "#0096fd",
  stroke: "#0096fd",
};

const STYLE_CIRCLE = {
  fill: "#d1d1e6",
  stroke: "#d1d1e6",
  cursor: "ew-resize",
};

const STYLE_CIRCLE2 = {
  fill: "none",
  stroke: "#0096fd",
  cursor: "ew-resize",
};

const Item = function (
  { layer, item, scene, catalog, state },
  { itemsActions }
) {
  let { x, y, rotation } = item;
  let properties = item.properties.toJS();
  //  
  let scaleX =
    "scaleX" in properties
      ? Number.isInteger(properties.scaleX) && properties.scaleX > 5
        ? properties.scaleX / 100
        : properties.scaleX
      : 1.0;
  let scaleY =
    "scaleY" in properties
      ? Number.isInteger(properties.scaleY) && properties.scaleY > 5
        ? properties.scaleY / 100
        : properties.scaleY
      : 1.0;
  // const [bbox, setBBox] = useState(null);
  const [boundingClientRect, setBoundingClientRect] = useState({
    topLeftX: 0,
    topLeftY: 0,
    topRightX: 0,
    topRightY: 0,
    bottomLeftX: 0,
    bottomLeftY: 0,
    bottomRightX: 0,
    bottomRightY: 0,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const node = document.getElementById(`resize-${item.id}`);
    if (!node) return;

    try {
      const bbox = node.getBBox();
      const w = bbox.width;
      const h = bbox.height;
      if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
        return;
      }

      setBoundingClientRect({
        topLeftX: bbox.x,
        topLeftY: bbox.y,
        topRightX: bbox.x + w,
        topRightY: bbox.y,
        bottomLeftX: bbox.x,
        bottomLeftY: bbox.y + h,
        bottomRightX: bbox.x + w,
        bottomRightY: bbox.y + h,
        width: w,
        height: h,
      });
    } catch (e) {
      // SVG not ready yet
    }
  }, [item.id, scaleX, scaleY, x, y, rotation]);

  const rotationHandleOffset =
    Number.isFinite(boundingClientRect.height) && boundingClientRect.height > 0
      ? boundingClientRect.height + 10
      : null;
  let renderedItem = catalog
    .getElement(item.type)
    .render2D(item, layer, scene, {
      scaleX,
      scaleY,
    });
  return (
    <g
      data-element-root
      display={item.visible ? "block" : "none"}
      data-prototype={item.prototype}
      data-id={item.id}
      data-selected={item.selected}
      data-layer={layer.id}
      style={
        item.selected
          ? {
              cursor: "move",
              fontSize: `${
                12 / state.getIn(["react-planner"]).viewer2D.toJS().a < 12
                  ? 12
                  : 12 /
                    (state.getIn(["react-planner"]).viewer2D.toJS().a < 0.3
                      ? state.getIn(["react-planner"]).viewer2D.toJS().a * 1.5
                      : state.getIn(["react-planner"]).viewer2D.toJS().a)
              }px`,
            }
          : {
              fontSize: `${
                12 / state.getIn(["react-planner"]).viewer2D.toJS().a < 12
                  ? 12
                  : 12 /
                    (state.getIn(["react-planner"]).viewer2D.toJS().a < 0.3
                      ? state.getIn(["react-planner"]).viewer2D.toJS().a * 1.5
                      : state.getIn(["react-planner"]).viewer2D.toJS().a)
              }px`,
            }
      }
      transform={
        // item.type.includes("stairs")
        false
          ? `translate(${x},${y}) rotate(${rotation})`
          : `translate(${x},${y}) rotate(${rotation})`
      }
    >
      <If condition={item.selected && rotationHandleOffset !== null}>
        <g
          data-element-root
          data-prototype={item.prototype}
          data-id={item.id}
          data-selected={item.selected}
          data-layer={layer.id}
          data-part="rotation-anchor"
        >
          <circle
            cx="0"
            cy={rotationHandleOffset}
            r="10"
            style={STYLE_CIRCLE}
          />
          <line
            x1="0"
            y1={0}
            x2="0"
            y2={rotationHandleOffset}
            stroke="#d1d1e6"
            strokeWidth="4"
          />
        </g>
      </If>
      <g
        id={`resize-${item.id}`}
        transform={`scale(${scaleX},${
          item.type.includes("firesafety") ? scaleX : scaleY
        })`}
      >
        {React.isValidElement(renderedItem)
          ? renderedItem
          : renderedItem.element}
        {boundingClientRect.width > 0 && boundingClientRect.height > 0 && (
          <rect
            x={boundingClientRect.topLeftX}
            y={boundingClientRect.topLeftY}
            width={boundingClientRect.width}
            height={boundingClientRect.height}
            fill="transparent"
            pointerEvents="all"
            style={{ cursor: item.selected ? "move" : "pointer" }}
          />
        )}
      </g>
      {!React.isValidElement(renderedItem) && item.selected && (
        <Fragment>
          <g
            data-element-root
            data-prototype={item.prototype}
            data-id={item.id}
            data-selected={item.selected}
            data-layer={layer.id}
            data-part="resize-box"
          >
            <rect
              // x={-(bbox.x + bbox.width / 2)}
              // y={bbox.y + bbox.height / 2}
              x={boundingClientRect.topLeftX}
              y={boundingClientRect.topLeftY}
              width="15"
              height="15"
              fill="#d1d1e6"
            />
          </g>
          <g
            data-element-root
            data-prototype={item.prototype}
            data-id={item.id}
            data-selected={item.selected}
            data-layer={layer.id}
            data-part="resize-box"
          >
            <rect
              // x={-(bbox.x + bbox.width / 2)}
              // y={-(bbox.y + bbox.height / 2)}
              x={boundingClientRect.topRightX}
              y={boundingClientRect.topRightY}
              width="15"
              height="15"
              fill="#d1d1e6"
            />
          </g>
          <g
            data-element-root
            data-prototype={item.prototype}
            data-id={item.id}
            data-selected={item.selected}
            data-layer={layer.id}
            data-part="resize-box"
          >
            <rect
              // x={bbox.x + bbox.width / 2}
              // y={bbox.y + bbox.height / 2}
              x={boundingClientRect.bottomLeftX}
              y={boundingClientRect.bottomLeftY}
              width="15"
              height="15"
              fill="#d1d1e6"
            />
          </g>
          <g
            data-element-root
            data-prototype={item.prototype}
            data-id={item.id}
            data-selected={item.selected}
            data-layer={layer.id}
            data-part="resize-box"
          >
            <rect
              // x={bbox.x + bbox.width / 2}
              // y={-(bbox.y + bbox.height / 2)}
              x={boundingClientRect.bottomRightX}
              y={boundingClientRect.bottomRightY}
              width="15"
              height="15"
              fill="#d1d1e6"
            />
          </g>
        </Fragment>
      )}
    </g>
  );
};
function mapStateToProps(reduxState) {
  return {
    state: reduxState,
  };
}
export default connect(mapStateToProps)(Item);

Item.propTypes = {
  item: PropTypes.object.isRequired,
  layer: PropTypes.object.isRequired,
  scene: PropTypes.object.isRequired,
  catalog: PropTypes.object.isRequired,
};
Item.contextTypes = {
  itemsActions: PropTypes.object.isRequired,
};
